module.exports = __webpack_public_path__ + "static/media/Dugtrio_gaussian2.3d1c8ef4.png";